/* eslint-disable @typescript-eslint/camelcase */
import { Component } from 'vue-property-decorator'
import { FormStructure } from '@master/model/structure/FormStructure'
import { FormBaseMixin } from './FormBaseMixin'
import { RecruitSubsidyReimbursement, RecruitSubsidyReimbursementFields, SubsidyTypeOptions } from '@core/model/recruit/forms/RecruitSubsidyReimbursement'
import { ReimbursableExamTypeOptions } from '@master/model/options/ExamTypeOptions'
@Component
export class RecruitSubsidyReimbursementMixin extends FormBaseMixin {
  protected type = RecruitSubsidyReimbursement

  get claimantInfoStructure (): FormStructure<RecruitSubsidyReimbursementFields> {
    return [
      {
        label: 'Date of Submission',
        key: 'submissionDate',
        type: 'date'
      },
      {
        label: 'Payable to (PLEASE SPECIFY IF CLAIMANT DETAILS DIFFERS)',
        key: 'payableTo'
      },
      {
        label: 'Subsidy',
        key: 'subsidy',
        type: 'smart',
        disabled: true,
        options: SubsidyTypeOptions
      }
    ]
  }

  get reimburseInfoStructure (): FormStructure<RecruitSubsidyReimbursementFields> {
    return [
      {
        label: 'Examinations',
        key: 'exams',
        type: 'smart',
        multiple: true,
        options: ReimbursableExamTypeOptions
      },
      {
        label: 'Total Costs',
        key: 'totalCosts',
        type: 'currency'
      },
      {
        label: `50% Reimbursed by ${this.projectInfo.companyShortName}`,
        key: 'reimbursed',
        type: 'currency'
      },
      {
        label: 'RNF Approval Date',
        key: 'rndApprovalDate',
        type: 'date'
      }
    ]
  }
}
